// TODO: ファイル名をquery.tsに変更する
import { isEmpty } from 'es-toolkit/compat'

/**
 * URL内に指定したクエリが存在するかを検証する。
 * 静的な場合はこっちを使えばOK
 * @param key keyを指定
 * @param value valueを指定。anyの場合はkeyがあれば良い
 * @returns
 */
export const hasQuery = (key: string, value: string | 'any') => {
  const query = getQuery(key)
  if (value === 'any') {
    return !!query
  }
  return query === value
}

export const getQuery = (key: string): string | null => {
  const url = new URL(window.location.href)
  return url.searchParams.get(key)
}

export const deleteQuery = (key: string) => {
  const url = new URL(window.location.href)
  url.searchParams.delete(key)
  window.history.replaceState(null, '', url.toString())
}

export const setQuery = (key: string, value: string) => {
  const url = new URL(window.location.href)
  url.searchParams.set(key, value)
  window.history.replaceState(null, '', url.toString())
}
/**
 * 何か1つでもクエリを持っているかどうか
 * @param url
 * @returns
 */
export const hasAnyQuery = (url: string) => {
  const urlObj = new URL(url)
  return !isEmpty(urlObj.search)
}
